export default {"src":"/_next/static/media/Unibase.e4736a96.svg","height":60,"width":200,"blurWidth":0,"blurHeight":0};